// extracted by mini-css-extract-plugin
export default {"twoStepContainer":"styles_twoStepContainer__SS6cb"};